import { useMutation } from '@tanstack/react-query';

import { APIClient } from ':cloud/state/Api';

type UpdateProtocolLimitsRequest = {
  orgId: string;
  protocolKey: string;
  newLimit: number;
};

async function updateProtocolLimits(
  orgId: string,
  protocolKey: string,
  newLimit: number,
): Promise<null> {
  const path = `/v1/customers/${orgId}/limits`;
  await APIClient.post<null>(path, {
    userId: orgId,
    resourceType: protocolKey,
    clusterLimit: newLimit,
  });
  return null;
}

export function useUpdateProtocolLimits() {
  return useMutation({
    mutationFn: async (item: UpdateProtocolLimitsRequest) =>
      updateProtocolLimits(item.orgId, item.protocolKey, item.newLimit),
    meta: {
      errorMsg: `An error occurred when updating your test limits. Please retry`,
      /** Does not support optimistc updates */
      successMsg: 'Successfully updated your cluster limits. Refresh page to preview updated list.',
    },
  });
}
